



















































































































































































































































































import { Component, Watch } from 'vue-property-decorator'
import Icon from '@/components/Icon.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import Select from '@/components/Select.vue'
import ScrollView from '@/components/ScrollView.vue'
import Input from '@/components/inputs/Input.vue'
import SharedFunctions from '@/views/app/management/review-statements/SharedFunctions'
import { mixins } from 'vue-class-component'
import { ETemplateType } from '@zunta/configurations/dist/types/template'
import { ERecipientType } from '@zunta/configurations/dist/types/resident'
import { NoCache } from '@/decorators/NoCache'
import { EUserPermissions, IResident, isString } from '@zunta/configurations'
import FileInput from '@/components/inputs/FileInput.vue'
import { User } from '@/classes/User'
import Api from '@/api'

const groupBy = require('lodash.groupby')
const uniq = require('lodash.uniq')

@Component({
  components: {
    FileInput,
    Input,
    ScrollView,
    Select,
    TextArea,
    Checkbox,
    Icon
  }
})
export default class AddMessageLetter extends mixins(SharedFunctions) {
  APP_URL: string = process.env.VUE_APP_APP_URL
  user: User = Api.getUser() as User
  ETemplateType: any = ETemplateType
  EUserPermissions: any = EUserPermissions
  activeTab: ETemplateType = ETemplateType.MESSAGE
  showRecipientsList: boolean = false
  changedStatementMessagesStates: any[] = []
  addStatement: any = {
    title: '',
    body: ''
  }
  fileName: string = ''
  selectedLetterTemplate: number | string | null = null
  selectedMessageTemplate: number | string | null = null
  selectedRecipients: number[] = []
  // isMessageTitleValid: boolean = false
  isMessageBodyValid: boolean = false
  isMessageLetterValid: boolean = false
  isLoadingFile: boolean = false

  isLoading: boolean = false

  @Watch('addStatement', { deep: true })
  removeInvalidIfEmpty () {
    this.$nextTick(() => {
      if (!this.addStatement.body.length) {
        // @ts-ignore
        // this.$refs['statementTitle'].isError = false
        // @ts-ignore
        this.$refs['statementBody'].isError = false
      }
      // if (!this.addStatement.title.length && !this.addStatement.body.length) {
      //   // @ts-ignore
      //   this.$refs['statementTitle'].isError = false
      //   // @ts-ignore
      //   this.$refs['statementBody'].isError = false
      // }
    })
  }

  get extendedStatementMessage () {
    if (!this.statementMessages || (this.statementMessages && !this.statementMessages.length)) return {}
    const groupedBy = groupBy(this.statementMessages, 'template.id')
    const groupedBy2 = groupBy(this.statementMessages, 'template')
    delete groupedBy2['[object Object]']
    let extendedObj: any = {}
    Object.keys(groupedBy).forEach(item => {
      let items = groupedBy[item]
      if (groupedBy2[item]) {
        items = items.concat(groupedBy2[item])
      }
      extendedObj[item] = {
        items: items,
        showOptions: true
      }
    })
    delete extendedObj['undefined']
    return extendedObj
  }

  get groupedByResidentRecipientBatchStatements () {
    if (!this.selectedStatement || !this.batchStatements) {
      return []
    }
    const residentName: string = this.residentFullName
    return this.batchStatements.filter((item: any) => item.recipient &&
      ((item.recipient.firstName ? item.recipient.firstName : '') +
        (item.recipient.lastName ? item.recipient.lastName : '')
      ) === residentName)
  }

  get residentFullName () {
    if (!this.selectedStatement || !this.batchStatements) {
      return ''
    }
    return (
        (this.selectedStatement.resident as IResident).firstName
          ? (this.selectedStatement.resident as IResident).firstName
          : ''
      ) +
      (
        (this.selectedStatement.resident as IResident).lastName
          ? (this.selectedStatement.resident as IResident).lastName
          : ''
      )
  }

  get groupedByNonResidentRecipientBatchStatements () {
    if (!this.selectedStatement || !this.batchStatements) {
      return []
    }
    const residentName: string = this.residentFullName
    return this.batchStatements.filter((item: any) => item.recipient &&
      ((item.recipient.firstName ? item.recipient.firstName : '') +
        (item.recipient.lastName ? item.recipient.lastName : '')
      ) !== residentName)
  }

  @NoCache
  get selectedRecipientsListNames () {
    if (this.batchStatements && this.batchStatements.length) {
      return uniq(this.batchStatements.map((item: any) => this.getRecipientLabel(item.recipient))).join(', ')
    }
    return []
  }

  getStatementCheckedStatus (key: string, statementId: number) {
    const obj = this.extendedStatementMessage[key].items.find((item: any) => item.statement === statementId)
    return !!(obj && obj.active)
  }

  toggleSelectedResidentRecipientsToAdd (flag: boolean) {
    this.groupedByResidentRecipientBatchStatements.forEach((item: any) => {
      this.toggleSelectedRecipientsToAdd(flag, item.id)
    })
  }

  toggleSelectedRecipientsToAdd (flag: boolean, value: number) {
    if (flag) {
      this.selectedRecipients.push(value)
      return
    }
    const index = this.selectedRecipients.findIndex((item: number) => item === value)
    this.selectedRecipients.splice(index, 1)
  }

  @Watch('batchStatements', { deep: true, immediate: true })
  batchStatementUpdate () {
    this.clearMessageForm()
    this.setSelectedRecipients()
  }

  setSelectedRecipients () {
    if (Array.isArray(this.batchStatements)) {
      this.selectedRecipients = this.batchStatements.map((item: any) => item.id)
    }
  }

  openTemplateNewPage (type: string) {
    const routeData = this.$router.resolve(
      {
        name: 'management-template',
        params: { templateId: 'new' },
        query: {
          type: type
        }
      }
    )
    // @ts-ignore
    this.$locationManager.openNewTab(routeData.href, true)
  }

  setActiveTab (tab: ETemplateType) {
    this.isLoadingFile = false
    this.activeTab = tab
  }

  getRecipientLabel (recipient: any) {
    if (!recipient) return ' '
    return (recipient.firstName ? recipient.firstName : '') +
      (recipient.lastName ? (' ' + recipient.lastName) : '')
  }

  getTypeLabel (recipientType: ERecipientType) {
    switch (recipientType) {
      case ERecipientType.MAIL:
        return 'Mail'
      case ERecipientType.EMAIL:
        return 'Email'
      case ERecipientType.ROOM:
        return 'Room'
      default:
        return ''
    }
  }

  cancelForm () {
    this.isLoadingFile = false
    switch (this.activeTab) {
      case ETemplateType.MESSAGE:
        this.clearMessageForm()
        break
      case ETemplateType.LETTER:
        this.setLetterForm(null)
        break
      case ETemplateType.LETTER_PDF:
        this.selectPDFLetterToUpload(null)
        break
    }
  }

  submitForm () {
    this.addStatementMessageLetter()
  }

  clearMessageForm () {
    this.addStatement.title = ''
    this.addStatement.body = ''
    this.addStatement.templateName = ''
    this.selectedMessageTemplate = null
    this.selectedLetterTemplate = null
    this.$nextTick(() => {
      if (this.$refs['selectTemplate']) {
        // @ts-ignore
        this.$refs['selectTemplate'].isError = false
      }
      if (this.$refs['statementLetter']) {
        // @ts-ignore
        this.$refs['statementLetter'].isError = false
      }
    })
  }

  async fetchTpl (opened: boolean) {
    if (!opened) {
      return
    }
    try {
      this.isLoading = true
      await this.fetchTemplates()
    } finally {
      this.isLoading = false
    }
  }

  async applyMessageChanges () {
    if (this.selectedStatement && this.selectedStatement.id) {
      const payload = {
        currentStatementId: +this.selectedStatement.id,
        statementMessages: this.statementMessages
      }
      this.$eventBus.$emit('loading:enable', { message: 'Update Statement' })
      const response = await this.statementModuleInstance.updateResidentMessageLetterV2(payload)
      if (!isString(response)) {
        if (response && response.message) {
          this.$eventBus.$emit('notify', {
            color: 'var(--status-error-color)',
            message: Array.isArray(response.message) ? response.message.join('\n') : response.message,
            header: `Toggle Message`,
            icon: 'warning'
          })
        }
      }

      await this.statementModuleInstance.fetchStatementMessages({
        statementId: (this.selectedStatement.resident as IResident).id,
        batchId: this.batchID
      })
      await this.fetchList()
      this.$eventBus.$emit('loading:disable')
      this.clearMessageForm()
      this.$forceUpdate()
      this.$eventBus.$emit('comments:update')
      this.changedStatementMessagesStates = []
    }
  }

  getTemplateLimitedBody (html: string) {
    const maxLength = 150
    const div = document.createElement('div')
    div.innerHTML = html
    const p: any = div.querySelector('p')
    let body = p ? p.innerText : html
    if (body.length <= maxLength) {
      return body
    } else {
      return `${body.substr(0, maxLength)}...`
    }
  }

  setMessageForm (value: any) {
    const { title, body, templateName } = this.messagesList.find((item: any) => item.id === +value)
    this.selectedMessageTemplate = value
    this.addStatement.title = title
    this.addStatement.templateName = templateName
    this.addStatement.body = body.replace(/(<([^>]+)>)/gi, ' ').replace(/  +/g, ' ').trim()
    this.$nextTick(() => {
      this.validateAddMessageLetterForm()
    })
  }

  validateAddMessageLetterForm () {
    if (this.activeTab === ETemplateType.MESSAGE) {
      // this.isMessageTitleValid = !!this.addStatement.title
      this.isMessageBodyValid = !!this.addStatement.body
      // @ts-ignore
      // this.$refs['statementTitle'].validate()
      // @ts-ignore
      this.$refs['statementBody'].validate()
      return
    }

    if (this.activeTab === ETemplateType.LETTER) {
      this.isMessageLetterValid = !!this.selectedLetterTemplate
      // @ts-ignore
      this.$refs['statementLetter'].validate()
      return
    }

    if (this.activeTab === ETemplateType.LETTER_PDF) {
      this.isMessageLetterValid = !!this.fileName
      // @ts-ignore
      this.$refs['statementFile'].validate()
    }
  }

  setLetterForm (value: any) {
    this.selectedLetterTemplate = value
  }

  async addStatementMessageLetter () {
    this.validateAddMessageLetterForm()
    const isStatement = this.selectedStatement && this.selectedStatement.id
    const isRecipient = this.selectedRecipients && this.selectedRecipients.length
    if (
      // (this.isMessageLetterValid || (this.isMessageTitleValid && this.isMessageBodyValid)) &&
      (this.isMessageLetterValid || (this.isMessageBodyValid)) &&
      isStatement &&
      isRecipient &&
      this.selectedStatement
    ) {
      const payload: any = {
        statementIds: this.selectedRecipients,
        currentStatementId: +(this.selectedStatement.resident as IResident).id
      }
      this.$eventBus.$emit('loading:enable', { message: 'Update Statement' })
      switch (this.activeTab) {
        case ETemplateType.MESSAGE:
          payload.type = ETemplateType.MESSAGE
          payload.templateName = this.addStatement.templateName
          payload.title = this.addStatement.title ? this.addStatement.title : ''
          payload.body = `<p>${this.addStatement.body}</p>`
          break
        case ETemplateType.LETTER:
          payload.type = ETemplateType.LETTER
          payload.templateId = this.selectedLetterTemplate
          break
        case ETemplateType.LETTER_PDF:
          payload.type = ETemplateType.LETTER_PDF
          payload.fileName = this.fileName
          // @ts-ignore
          payload.title = this.$refs['statementFile'].selectedFile
          break
      }

      const response = await this.statementModuleInstance.addStatementMessageLetterV2(payload)
      if (!isString(response)) {
        if (response && response.message) {
          this.$eventBus.$emit('notify', {
            color: 'var(--status-error-color)',
            message: Array.isArray(response.message) ? response.message.join('\n') : response.message,
            header: `Add Statement Message`,
            icon: 'warning'
          })
        }
      }

      await this.statementModuleInstance.fetchStatementMessages({
        statementId: (this.selectedStatement.resident as IResident).id,
        batchId: this.batchID
      })
      await this.fetchList()
      this.$eventBus.$emit('loading:disable')
      this.$eventBus.$emit('comments:update')
      this.fileName = ''
      // @ts-ignore
      this.$refs['statementFile'].clear()
      this.$forceUpdate()
      this.clearMessageForm()
    }
  }

  async selectPDFLetterToUpload (item: any): Promise<any> {
    if (!item) {
      this.fileName = ''
      // @ts-ignore
      this.$refs['statementFile'].clear()
      return
    }
    this.isLoadingFile = true
    const res = await this.templateModuleInstance.uploadPDFLetter(item)
    if (typeof res === 'string') {
      const regex = /pdf-letters\/(.*)/gm
      this.fileName = res.replace(regex, '$1')
    }
    this.isLoadingFile = false
  }

  toggleShowOptions (index: number | string) {
    this.extendedStatementMessage[index].showOptions = !this.extendedStatementMessage[index].showOptions
    this.$forceUpdate()
  }

  setCommentResidentRecipient (flag: boolean, templateId: number) {
    this.groupedByResidentRecipientBatchStatements.forEach((item: any) => {
      this.setCommentRecipient(flag, item, templateId)
    })
  }

  async toggleStatementMessageState (statementMessage: any) {
    const templateId = statementMessage.items[0].template.id
      ? statementMessage.items[0].template.id
      : statementMessage.items[0].template
    const flag = !(statementMessage.items.findIndex((item: any) => item.active === true) > -1)

    this.setCommentResidentRecipient(flag, templateId)

    this.groupedByNonResidentRecipientBatchStatements.forEach((item: any) => {
      this.setCommentRecipient(flag, item, templateId)
    })

    if (!this.groupedByNonResidentRecipientBatchStatements.length && !this.groupedByResidentRecipientBatchStatements.length) {
      this.setCommentRecipient(flag, this.selectedStatement, templateId)
    }
  }

  setCommentRecipient (flag: boolean, statement: any, templateId: number) {
    const arr = JSON.parse(JSON.stringify(this.statementMessages))
    const index = this.statementMessages.findIndex((item: any) => item.statement === statement.id && item.template.id === templateId)
    if (index > -1) {
      arr[index].active = flag
    } else {
      const newObj = {
        active: flag,
        statement: statement.id,
        template: +templateId
      }
      arr.push(newObj)
    }
    this.statementModuleInstance.UPDATE_STATEMENT_MESSAGES(JSON.parse(JSON.stringify(arr)))
    const itemIndex = this.changedStatementMessagesStates.findIndex((item: any) => statement.id === item.statement &&
      (item.template === templateId || item.template.id === templateId))
    if (itemIndex > -1) {
      this.changedStatementMessagesStates.splice(itemIndex, 1)
    } else {
      const newItem = this.statementMessages.find((item: any) => statement.id === item.statement && (item.template === templateId || item.template.id === templateId))
      this.changedStatementMessagesStates.push(newItem)
    }
  }
}
